import React, { useState } from 'react';
import { ReadFilled } from '@ant-design/icons';
import { Button, Text } from 'components';
import {
  CardAvatar,
  CardHeader,
  CardProgress,
  CenterTextWrapper,
  VerticalSpace,
} from '@brokerbay/design-components';
import {
  MarketingBadgeApple,
  MarketingBadgeGoogle,
} from 'components/MarketingBadges';
import { message } from 'antd';
import { useUserOnboardingContext } from '../../contexts/UserOnboardingContext';

export const LinkToAppView = () => {
  const [url, setUrl] = useState<string>('#');
  const userOnboardingContext = useUserOnboardingContext();

  React.useEffect(() => {
    message.success('Account created');
    (async () => {
      const onboardingUrl =
        await userOnboardingContext!.completeOnboardingUrl();
      setUrl(onboardingUrl);
    })();
  }, []);

  return (
    <VerticalSpace>
      <CardHeader
        title="Download and install the app"
        icon={<CardAvatar icon={ReadFilled} />}
      />

      <CenterTextWrapper>
        <Text>
          Want everything at your fingertips? Download the app by searching
          &apos;BrokerBay&apos; or &apos;Supra&apos; or use one of the links
          below.
        </Text>
      </CenterTextWrapper>

      <CenterTextWrapper>
        <MarketingBadgeApple />
        <MarketingBadgeGoogle />
      </CenterTextWrapper>

      <Button type="primary" block data-cy="button-login" href={url}>
        Go to Dashboard
      </Button>

      <CardProgress percent={(5 / 5) * 100} />
    </VerticalSpace>
  );
};
